import { render, staticRenderFns } from "./MaturityChoosePopUp.vue?vue&type=template&id=6678f86d&scoped=true&"
import script from "./MaturityChoosePopUp.vue?vue&type=script&lang=js&"
export * from "./MaturityChoosePopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6678f86d",
  null
  
)

export default component.exports